export default __webpack_public_path__ + "static/media/2157.4331dcbb.png";